<template>
  <b-dropdown
    right
    size="sm"
    :text="buttonText"
    class="mr-1"
    v-if="files.length > 0"
    boundary="viewport"
    menu-class="project-docs-dropdown-menu"
  >
    <b-dropdown-item
      v-for="(file, index) in files"
      :key="index"
      :href="`/api/media/file/${file.path}?jwt=${accessToken}`"
      target="_blank"
    >
      {{ file.label }}
    </b-dropdown-item>
  </b-dropdown>
</template>
<script>
export default {
  props: {
    item: Object,
    accessToken: String,
    buttonText: String,
    documentType: String,
  },
  computed: {
    files() {
      if (!this.item || !this.item.files) return [];

      const isImagePath = (p) =>
        /\.(jpe?g|png|webp|gif|heic|heif|bmp|svg)$/i.test(p || '');

      if (this.documentType) {
        const fileType = this.item.files[this.documentType];
        if (!fileType?.paths?.length) {
          return [];
        }
        return fileType.paths
          .filter((p) => !isImagePath(p))
          .map((path, index) => ({
            path,
            label: this.typeToLabel(this.documentType, index),
          }));
      }

      return Object.keys(this.item.files)
        .filter((type) => this.item.files[type]?.paths?.length > 0)
        .map((type) =>
          this.item.files[type].paths
            .filter((p) => !isImagePath(p))
            .map((path, index) => ({
              path,
              label: this.typeToLabel(type, index),
            })),
        )
        .flat();
    },
  },
  methods: {
    typeToLabel(type, index) {
      switch (type) {
        case 'picture_before':
          return this.$t('jobs.image.start');
        case 'picture_after':
          return this.$t('jobs.image.finish');
        case 'protocol':
        case 'planning_customer':
        case 'planning_partner':
          return this.$t(`jobs.image.${type}`, { index });
        case 'customer_quote':
          return this.$t('jobs.image.accepted-customer-quote');
        case 'brand_quote':
          return this.$t('jobs.image.accepted-brand-quote');
      }
      return this.$t(`projects.image.${type}`);
    },
  },
};
</script>

<style scoped>
::v-deep .project-docs-dropdown-menu {
  max-height: 300px !important; /* Overrides Bootstrap's inline styles */
  overflow-y: auto !important;
  overflow-x: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  position: absolute;
}

::v-deep .project-docs-dropdown-menu::-webkit-scrollbar {
  width: 6px;
}

::v-deep .project-docs-dropdown-menu::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 3px;
}
</style>
